import { Preferences } from "../../profile/objects/preferences";
import { DEPARTURE_AIRPORT_MODULE, DEFAULT_COLUMN } from "../constant/departureAirportConstant";
import { Column } from "../objects/column";
import { setListPreference, ListPreferenceResult } from "../../utils/list/utils/setListPreference";

export const setDepartureAirportPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: DEPARTURE_AIRPORT_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });